'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { usePathname } from 'next/navigation';
import { CONTEXT_TYPES, ResourceContextMenuProvider, useResourceContextMenu } from '@udemy-v2/react-resource-context-menu';
import { TrackedCourse } from '../../context/clp-course-provider.react-component';
interface CLPContextMenuInnerProps {
  course: TrackedCourse;
}
const CLPContextMenu = t0 => {
  const $ = _c(5);
  const {
    course
  } = t0;
  const pathname = usePathname();
  const {
    getCourseCardContextMenu
  } = useResourceContextMenu();
  const t1 = parseInt(course.id);
  let t2;
  if ($[0] !== course.title || $[1] !== getCourseCardContextMenu || $[2] !== pathname || $[3] !== t1) {
    t2 = getCourseCardContextMenu({
      id: t1,
      title: course.title,
      url: pathname,
      isPublished: true,
      customCategoryIds: []
    }, {
      context: CONTEXT_TYPES.CLP
    });
    $[0] = course.title;
    $[1] = getCourseCardContextMenu;
    $[2] = pathname;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2 as React.ReactElement | null;
};
interface CLPResourceContextMenuProps {
  course: TrackedCourse;
}

/**
 * Resource context menu for the Course Landing Page, only rendered for organization users.
 * Renders two independent entry points: a "Share" menu (Assign / Recommend / Share to MS
 * Teams) and, for Enterprise-tier orgs, a second "more actions" menu (custom category /
 * learning path / course activity). Both entry points and their org-role/plan gating live
 * inside `@udemy-v2/react-resource-context-menu`.
 */
export const CLPResourceContextMenu = t0 => {
  const $ = _c(2);
  const {
    course
  } = t0;
  let t1;
  if ($[0] !== course) {
    t1 = <ResourceContextMenuProvider><CLPContextMenu course={course} /></ResourceContextMenuProvider>;
    $[0] = course;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};